"use strict";
exports.__esModule = true;
var ramda_1 = require("ramda");
exports["default"] = ramda_1.pick([
    'autofocus',
    'cols',
    'dirname',
    'disabled',
    'form',
    'maxlength',
    'name',
    'placeholder',
    'readonly',
    'required',
    'rows',
    'wrap',
]);
//# sourceMappingURL=textarea.js.map